module.exports = __webpack_public_path__ + "img/measurement_info_back_neck_right.20fce527.jpg";